export enum SSHErrorCode {
  SESSION_NOT_FOUND = "SESSION_NOT_FOUND",
  CONNECTION_FAILED = "CONNECTION_FAILED",
  STREAM_ERROR = "STREAM_ERROR",
  NOT_ESTABLISHED = "NOT_ESTABLISHED",
}

export interface SSHError {
  message: string;
  code?: SSHErrorCode;
}
